"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oasis = void 0;
const weth_1 = require("./weth");
const DEX_PARAMS = {
    1: {
        otc: "0x794e6e91555438aFc3ccF1c5076A74F42133d08D",
        weth: weth_1.Weth.getAddress(1),
        factory: "0x4678f0a6958e4d2bc4f1baf7bc52e8f3564f3fe4"
    }
};
class Oasis {
    static getExchangeParams(network = 1) {
        return DEX_PARAMS[network];
    }
}
exports.Oasis = Oasis;
//# sourceMappingURL=oasis.js.map